export default function initAccordionMenu() {
    const menuAccordions = document.querySelectorAll(".menu-accordion");

    if (!menuAccordions.length) return;

    menuAccordions.forEach((menu) => {
        const accordionTabs = menu.querySelectorAll(".menu-accordion__tab");
        const accordionPanels = menu.querySelectorAll(".menu-accordion__panel");

        if (!accordionTabs.length || !accordionPanels.length) return;

        // Set initial state - first tab active by default
        const firstTab = accordionTabs[0];
        const firstPanel = accordionPanels[0];
        if (firstTab && firstPanel) {
            firstTab.classList.add("active");
            firstPanel.classList.add("active");
        }

        // Add click handlers to tabs
        accordionTabs.forEach((tab) => {
            tab.addEventListener("click", () => {
                activateTab(tab, accordionTabs, accordionPanels);
            });
        });
    });

    // Function to check if we're in mobile view
    const isMobileView = () => window.innerWidth < 768;

    // Function to handle tab activation
    const activateTab = (tab, accordionTabs, accordionPanels) => {
        const tabId = tab.getAttribute("data-tab");
        const isActive = tab.classList.contains("active");

        if (isMobileView()) {
            // En mobile : toggle behavior (ouvrir/fermer sans affecter les autres)
            if (isActive) {
                // Fermer le tab actuel
                tab.classList.remove("active");
                accordionPanels.forEach((panel) => {
                    if (panel.getAttribute("data-panel") === tabId) {
                        panel.classList.remove("active");
                    }
                });
            } else {
                // Ouvrir le tab
                tab.classList.add("active");
                accordionPanels.forEach((panel) => {
                    if (panel.getAttribute("data-panel") === tabId) {
                        panel.classList.add("active");
                    }
                });
            }
        } else {
            // En desktop : comportement classique (fermer tous les autres)
            accordionTabs.forEach((t) => t.classList.remove("active"));
            tab.classList.add("active");

            accordionPanels.forEach((panel) => {
                panel.classList.remove("active");
                if (panel.getAttribute("data-panel") === tabId) {
                    panel.classList.add("active");
                }
            });
        }

        if (isMobileView() && !isActive) {
            window.scrollTo({
                top: 0,
                behavior: "smooth",
            });
        }
    };
}

// Initialize on load
document.addEventListener("DOMContentLoaded", initAccordionMenu);
